"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTileLayer = void 0;
var react_1 = require("react");
var Localization_1 = require("../constants/Localization");
function useTileLayer(currentLanguage) {
    return react_1.useMemo(function () {
        return currentLanguage === Localization_1.LocalizationSettings.defaultLanguage
            ? process.env.MIX_LEAFLET_HY_TILE_LAYER
            : process.env.MIX_LEAFLET_EN_TILE_LAYER;
    }, [currentLanguage]);
}
exports.useTileLayer = useTileLayer;
